import Config from '@/config';
import http, { HttpPromise } from './http';

export default {
  // выбор для селектов - (заявка стать ген подрядчиком)
  gencontractorsTaxationFormOptions: async ():Promise<HttpPromise> => {
    const response = await http.post(`${Config.apiHost}/helpers/gencontractors/taxationForms/`);
    return response.data.result;
  },
  // выбор для селектов - (заявка новый лот на ген подряд)
  gencontractorsLotOptions: async ():Promise<HttpPromise> => {
    const response = await http.post(`${Config.apiHost}/helpers/gencontracts/lot/`);
    return response.data.result;
  },
};
